/**
 * @generated SignedSource<<5be4d54fd79cfe5aaf77af974d9c0ce6>>
 * @relayHash 24fbb3cff8b05eaa1a5b7d5ae6a6a9c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646

import type { ConcreteRequest } from 'relay-runtime';
export type ValidatePagePublishQuery$variables = {
  contentId: string;
  title?: string | null;
  type?: string | null;
};
export type ValidatePagePublishQuery$data = {
  readonly validatePagePublish: {
    readonly isValid: boolean;
    readonly message: string | null;
  } | null;
};
export type ValidatePagePublishQuery = {
  response: ValidatePagePublishQuery$data;
  variables: ValidatePagePublishQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "draft"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "PageValidationResult",
    "kind": "LinkedField",
    "name": "validatePagePublish",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isValid"
      },
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ValidatePagePublishQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ValidatePagePublishQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "24fbb3cff8b05eaa1a5b7d5ae6a6a9c0",
    "id": "be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646",
    "metadata": {},
    "name": "ValidatePagePublishQuery",
    "operationKind": "query",
    "text": "query ValidatePagePublishQuery($contentId:ID!,$type:String,$title:String){validatePagePublish(id:$contentId,status:\"draft\",type:$type,title:$title){isValid,message}}"
  }
};
})();

(node as any).hash = "8954a1a5f4b5c46209e8bdbdcef7f2f7";

export default node;
